export default __webpack_public_path__ + "static/media/pickachu2.aec47caa.png";